import dayjs from 'dayjs';

export const calculateLimitTime = (manufactureTimeValue) => {
  if (!manufactureTimeValue) return null;

  try {
    if (dayjs.isDayjs(manufactureTimeValue)) {
      return manufactureTimeValue.add(90, 'minute');
    }

    const manufactureDayjs = dayjs(manufactureTimeValue, 'HH:mm');
    if (manufactureDayjs.isValid()) {
      return manufactureDayjs.add(90, 'minute');
    }

    return null;
  } catch (error) {
    console.warn('Error calculando limit_time:', error);
    return null;
  }
};

export const recreateRegions = (templateRegions) => {
  const regions = templateRegions.map((x, index) => {
    x.index = index;
    x.isSelected = false;
    x.isVisible = true;
    return x;
  });
  return regions;
};

export const processFieldValue = (fieldName, value) => {
  if (value === undefined || value === null) return value;

  if (fieldName.toLowerCase().includes('date')) {
    if (dayjs.isDayjs(value) && value.isValid()) return value;

    const dateFormats = [
      'YYYY-MM-DD',
      'DD/MM/YYYY',
      'D/M/YYYY',
      'DD/MM/YY',
      'D/M/YY',
    ];

    if (typeof value === 'string') {
      for (const format of dateFormats) {
        const d = dayjs(value, format, true);
        if (d.isValid()) return d;
      }
    }
    return null;
  }

  if (fieldName.includes('time')) {
    if (dayjs.isDayjs(value) && value.isValid()) return value;
    const timeFormats = ['HH:mm', 'H:mm', 'HH:mm:ss'];
    if (typeof value === 'string') {
      for (const format of timeFormats) {
        const dayjsValue = dayjs(value, format);
        if (dayjsValue.isValid()) return dayjsValue;
      }
    }
    return null;
  }

  if (fieldName === 'elements' && typeof value === 'string') {
    if (!value) return [];
    return value
      .split(',')
      .map((v) => v.trim())
      .filter(Boolean);
  }
  if (fieldName.includes('docket_number')) {
    return value.toString();
  }
  if (fieldName.includes('reference_number')) {
    return value.toString();
  }

  if (fieldName === 'driver') {
    return value.toString();
  }

  return value;
};

export const formatFormData = (data) => {
  const formatted = { ...data };
  Object.keys(formatted).forEach((key) => {
    const value = formatted[key];
    // Date: dayjs object or string
    if (value && value.isValid && value.isValid()) {
      if (key.toLowerCase().includes('date')) {
        formatted[key] = value.format('DD/MM/YYYY');
      }
      if (key.toLowerCase().includes('time')) {
        formatted[key] = value.format('HH:mm');
      }
    }
    if (key === 'elements' && Array.isArray(value)) {
      formatted[key] = value.join(',');
    }

    if (key === 'docket_number') {
      formatted[key] = parseInt(value, 10);
    }
  });
  return formatted;
};

export const sortRegions = (fields, regions) => {
  return fields.map((region) => {
    const find = regions?.find((r) => {
      return r.data === region;
    });
    if (find) return find;
    else return { data: region };
  });
};

export const PRE_DELIVERY_NOTES_ATTRS = [
  'mash_control',
  'detailed_location',
  'arriving_time',
  'start_discharging_time',
  'finish_discharging_time',
  'arriving_date',
];
export const PRE_DELIVERY_NOTES_ATTRS_CEMEX = [
  'plant',
  'recipe',
  'delivered',
  'manufacture_time',
];

export const PRE_DELIVERY_NOTES_MASH_CONTROL_ATTRS = [
  'slump',
  'specimens_number',
  'mash_control_extra',
];

export const checkDiffTemplate = (regions, templateRegions) => {
  let check = false;
  templateRegions?.forEach((templateRegion) => {
    if (regions.data !== 'provider' && regions.data !== 'CIF') {
      const region = regions.find(
        (region) => region.data === templateRegion.data,
      );
      if (
        region &&
        !(
          region.x === templateRegion.x &&
          region.y === templateRegion.y &&
          region.width === templateRegion.width &&
          region.height === templateRegion.height
        )
      )
        check = true;
    }
  });
  return check;
};
